import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
}) => {
  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount={totalRecord}
      initialPage={dataFilter?.page}
      onChangePage={onChangePage}
      per_page={dataFilter?.limit}
    >
      {dataSource.length > 0 ? (
        dataSource.map((data) => (
          <tr className="db-table-body-tr" key={data._id}>
            <td className="db-table-body-td">{data.name}</td>
            <td className="db-table-body-td">{data.email}</td>
            <td className="db-table-body-td">{data.phone_no}</td>
            <td className="db-table-body-td">{data?.role_id?.name}</td>
<td className="db-table-body-td">
  {data.status === 1 
    ? <span className="active">Active</span>
    : <span className="inactive">Inactive</span>
  }
</td>


            {/* ── NEW: Biometric ID ───────────────────────────── */}
            <td className="db-table-body-td">{data.biometricId ?? '—'}</td>

            {/* Salary */}
            <td className="db-table-body-td">{data.salary}</td>

            {/* Action Buttons */}
            <td className="db-table-body-td hidden-print hidden-print-remove">
              <div className="flex justify-start items-center gap-1.5">
                <PermissionCheck permsission="view_employees">
                  <Link
                    to={`/admin/employees/show/${data._id}`}
                    className="db-table-action view"
                    state={{ employee: data }}
                  >
                    <i className="lab lab-view"></i>
                    <span className="db-tooltip">View</span>
                  </Link>
                </PermissionCheck>

                <PermissionCheck permsission="update_employees">
                  <button
                    data-modal="#sidebar"
                    className="db-table-action edit"
                    onClick={() => handleDrawerOpen(data._id)}
                  >
                    <i className="lab lab-edit-line"></i>
                    <span className="db-tooltip">edit</span>
                  </button>
                </PermissionCheck>

                <PermissionCheck permsission="delete_employees">
                  <button
                    className="db-table-action delete"
                    onClick={() => deleteRecord(data._id)}
                  >
                    <i className="lab lab-delete"></i>
                    <span className="db-tooltip">delete</span>
                  </button>
                </PermissionCheck>
              </div>
            </td>
          </tr>
        ))
      ) : (
        <IsLoadingNotFound
          isLoading={isLoading}
          colSpan={tableColumn.length}
        />
      )}
    </TableWrapServerSide>
  );
};

export default DataTable;
 